import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaInstagram } from "react-icons/fa";

const Contact = () => {
    return (
        <section id="iletisim" className="w-full">
            {/* Harita */}
            <div className="w-full h-[320px] md:h-[380px]">
                <iframe
                    title="Kahraman Ahşap Merdiven Konum"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3127.9481899674797!2d27.134756075804038!3d38.373319977456894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbdf22b96fc711%3A0x8ad90c5866b58cfe!2zU2V5aGFuLCA2MzAvMS4gU2suIE5vOjQ5LCAzNTM4MCBCdWNhL8Swem1pciwgVMO8cmtpeWU!5e0!3m2!1str!2sus!4v1763566264698!5m2!1str!2sus" // kendi embed URL'ini buraya koy
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>

            {/* Ulaşım + Çalışma Saatleri */}
            <div
                className="relative bg-cover bg-center bg-fixed"
                style={{ backgroundImage: "url('images/contact.png')" }} // arka plan görselin
            >
                {/* Koyu overlay */}
                <div className="absolute inset-0 bg-black/65" />

                <div className="relative max-w-5xl lg:max-w-6xl mx-auto px-6 py-16 lg:py-24 text-white">
                    {/* Ortadaki ikon + çizgi */}
                    <div className="flex flex-col items-center mb-12">
                        <a className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg" href="https://www.instagram.com/kahramanahsapmerdiven/" target="_blank" rel="noopener noreferrer">
                            <FaInstagram className="text-orange-500 text-2xl" />
                        </a>
                        <div className="w-24 h-[2px] bg-orange-500 mt-6" />
                    </div>

                    {/* İçerik kolonları */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-sm md:text-base">
                        {/* Ulaşım Bilgileri */}
                        <div className="space-y-6">
                            <h3 className="text-xl font-semibold mb-4">Ulaşım Bilgileri</h3>

                            <div className="flex items-start gap-3">
                                <FaMapMarkerAlt className="mt-1 text-orange-500" />
                                <div>
                                    <div className="text-xs uppercase tracking-widest text-gray-300">
                                        ADRES
                                    </div>
                                    <p className="text-sm md:text-base text-gray-100">
                                        630/1 Sk No 51 Karabağlar / İZMİR Türkiye
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start gap-3">
                                <FaPhoneAlt className="mt-1 text-orange-500" />
                                <div>
                                    <div className="text-xs uppercase tracking-widest text-gray-300">
                                        TELEFON
                                    </div>
                                    <p className="text-sm md:text-base text-gray-100">
                                        +90 532 748 67 68
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start gap-3">
                                <FaEnvelope className="mt-1 text-orange-500" />
                                <div>
                                    <div className="text-xs uppercase tracking-widest text-gray-300">
                                        E-POSTA
                                    </div>
                                    <p className="text-sm md:text-base text-gray-100">
                                        info@kahramanahsapmerdiven.com
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Çalışma Saatleri */}
                        <div>
                            <h3 className="text-xl font-semibold mb-4 text-center md:text-left">
                                Çalışma Saatleri
                            </h3>

                            <div className="space-y-2 text-gray-200">
                                {[
                                    { day: "Pazartesi", hours: "09:00 - 18:00" },
                                    { day: "Salı", hours: "09:00 - 18:00" },
                                    { day: "Çarşamba", hours: "09:00 - 18:00" },
                                    { day: "Perşembe", hours: "09:00 - 18:00" },
                                    { day: "Cuma", hours: "09:00 - 18:00" },
                                    { day: "Cumartesi", hours: "09:00 - 15:00" },
                                    { day: "Pazar", hours: "-" },
                                ].map((item) => (
                                    <div
                                        key={item.day}
                                        className="flex justify-between gap-6 text-sm md:text-base"
                                    >
                                        <span>{item.day}</span>
                                        <span className="text-gray-300">{item.hours}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
